import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { relative } from 'path';
import { DeviceType } from '../../providers/ViewportProvider';

export const useStyles = makeStyles<Theme, { device: DeviceType }>(
  (theme: Theme) => ({
    root: ({ device }) => ({
      position: "relative",
      height: '550px',
      maxHeight: '550px',
      width: "293px",
      maxWidth: "293px",
      padding: "15px",
      borderRadius:"17px",
      cursor: 'pointer',
      '&:hover': {
      },
      '&:active': {
      },
    }),
    media: {
      height: '300px',
      minHeight: '300px',
      borderRadius: "10px",
    },
    cardTitle: {
      paddingTop: "10px",
      fontSize: "24px",
      textTransform: "capitalize",
      lineHeight: "31px",
      fontWeight: 600,
      letterSpacing: "-0.03em",
    },
    cardSubtitle: {
      fontSize: "14px",
      textTransform: "capitalize",
      lineHeight: "17px",
      fontWeight: 500,
    },
    cardData: {
      fontSize: "25px",
      textTransform: "capitalize",
      lineHeight: "32px",
      fontWeight: 600,
    },
    cardSubData: {
      fontSize: "10px",
      textTransform: "capitalize",
      lineHeight: "17px",
      fontWeight: 500,
    },
    cardButton: {
      fontSize: "14px",
      textTransform: "capitalize",
      lineHeight: "19px",
      color: "#403A30",
      fontWeight: 500,
      borderRadius: "10px",
      backgroundColor: "#E1B456",
      display: "flex",
      flexDdirection: "row",
      justifyContent: "center",
      alignItems: "center",
      padding: "4px 9.83047px",
      gap: "3.93px",
    },
    raffleInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      fontSize: '18px',
      width: "100%",
      height: "200px"
    },
    detailsRow1: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    detailsRow2: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
    },
    detailsRow3: {
      display: 'flex',
      flexDirection: 'row',
    },
    ticketsSold: {
      width: '50%',
    },
    endingIn: {
      width: '100%',
    },
    ticketPrice: {
      width: '50%',
      display: " flex",
      justifyContent: "center",
      borderLeft: "dashed 1px #786E5C",
    },
    goToRaffle: {
      color: 'white',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    cardPrizesBadge: {
      fontSize: '12px',
      fontWeight: 'bold',
      width: '80px',
      textAlign: 'center',
      padding: '2px',
      position: 'absolute',
      top: '5px',
      left: '5px',
      color: 'black',
      backgroundColor: '#ff5f5f',
    },
    cardEndedBadge: {
      fontSize: '12px',
      fontWeight: 'bold',
      minWidth: '15px',
      minHeight: "15px",
      textAlign: 'center',
      padding: '2px',
      position: 'absolute',
      top: '10px',
      right: '10px',
      color: 'white',
      backgroundColor: '#fe005a',
      borderRadius: '50%',
    },
    cardLiveBadge: {
      fontSize: '12px',
      fontWeight: 'bold',
      minWidth: '15px',
      minHeight: "15px",
      textAlign: 'center',
      padding: '2px',
      position: 'absolute',
      top: '10px',
      right: '10px',
      color: 'white',
      backgroundColor: 'green',
      borderRadius: '50%',
    },
    cardFeaturedBadge: {
      fontSize: '12px',
      fontWeight: 'bold',
      width: '80px',
      textAlign: 'center',
      padding: '3px',
      position: 'absolute',
      top: '10px',
      left: '10px',
      color: 'black',
      backgroundColor: 'yellow',
      borderRadius: '2px',
    },
  })
);
